import member from './member';
import loading from './loading';
import modal from './modal';
import death from './death';
import hamburger from './hamburger';

export default {
  member,
  loading,
  modal,
  death,
  hamburger,
};
